import * as bootstrap from 'bootstrap';

let schoolDistrict = null;

export function initStudentSchools() {

  // console.log("Student Schools initiated");

  const studentGrade = document.getElementById("studentGrade");
  const searchBox = document.getElementById("schoolSearchBox");
  const dropdownButton = document.getElementById("schoolDropdownButton");
  const dropdownContainer = document.getElementById("schoolDropdownContainer");
  const hiddenInput = document.getElementById("studentSchool");
  const otherInput = document.getElementById("studentSchoolOther");
  
  const headerGroups = document.querySelectorAll(".dropdown-header-group");
  const items = document.querySelectorAll(".dropdown-item");

  function filterSchools() {
    const filterText = searchBox ? searchBox.value.toLowerCase().trim() : '';
    const selectedGrade = studentGrade ? studentGrade.value : '';

    headerGroups.forEach(group => {
      let visibleCount = 0;
      const headerElement = group.querySelector(".dropdown-header");
      const headerText = headerElement ? headerElement.textContent.toLowerCase() : '';
      const groupRows = group.querySelectorAll("li");
      
      groupRows.forEach(row => {
        const btn = row.querySelector(".dropdown-item");
        if (!btn) return;

        const btnValueAttr = btn.getAttribute("data-value") ? btn.getAttribute("data-value").toLowerCase() : '';
        const btnTextFallback = btn.textContent.toLowerCase().trim().replace(/\s+/g, ' ');
        
        const isOtherOption = btnValueAttr === 'other' || btnTextFallback.includes('other');

        let gradeMatches = true;
        if (!isOtherOption) {
          if (['5', '6', '7', '8'].includes(selectedGrade) && headerText.includes("high")) {
            gradeMatches = false; 
          } else if (['9', '10', '11'].includes(selectedGrade) && (headerText.includes("middle") || headerText.includes("k-8"))) {
            gradeMatches = false; 
          }
        }

        let textMatches = isOtherOption || btnValueAttr.includes(filterText) || btnTextFallback.includes(filterText);

        if (gradeMatches && textMatches) {
          row.style.removeProperty('display');
          visibleCount++;
        } else {
          row.style.setProperty('display', 'none', 'important');
        }
      });

      const isOtherGroup = group.getAttribute('data-group-id') === 'otherGroup' || headerText.includes('other');

      if (visibleCount === 0 && !isOtherGroup && (filterText !== '' || selectedGrade !== '')) {
        group.style.setProperty('display', 'none', 'important');
      } else {
        group.style.removeProperty('display');
      }
    });
  }

  // Helper to trap Enter/Return key actions inside our specialized menu text boxes
  function preventEnterSubmit(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault(); // Stop form submission or unintended button clicks
      e.stopPropagation();
      
      // If user hit Enter inside custom box, close the menu completely
      if (dropdownButton) {
        const bootstrapDropdown = bootstrap.Dropdown.getInstance(dropdownButton);
        if (bootstrapDropdown) bootstrapDropdown.hide();
      }
    }
  }

  if (searchBox) {
    searchBox.addEventListener('input', filterSchools);
    searchBox.addEventListener('keydown', preventEnterSubmit);
  }

  if (otherInput) {
    otherInput.addEventListener('click', (e) => e.stopPropagation());
    otherInput.addEventListener('keydown', preventEnterSubmit); // Block Enter key loops

    otherInput.addEventListener('input', () => {
      const typedValue = otherInput.value.trim();
      if (hiddenInput) hiddenInput.value = 'Other';
      window.schoolDistrict = 0;

      if (dropdownButton && dropdownButton.querySelector('span')) {
        dropdownButton.querySelector('span').textContent = typedValue !== '' ? typedValue : 'Select...';
      }
    });
  }

  items.forEach(item => {
    item.addEventListener('click', function () {
      const selectedValue = this.getAttribute('data-value');
      const selectedText = this.textContent.trim();

      if (selectedValue === 'Other' || selectedValue.toLowerCase() === 'other' || selectedText.toLowerCase().includes('other')) {
        if (otherInput) otherInput.focus();
        return;
      }
      
      schoolDistrict = this.getAttribute('data-district');
      window.schoolDistrict = schoolDistrict; 
      
      if (hiddenInput) hiddenInput.value = selectedValue;
      if (dropdownButton && dropdownButton.querySelector('span')) {
        dropdownButton.querySelector('span').textContent = selectedText;
      }

      if (otherInput) otherInput.value = '';
      
      if (dropdownButton) {
        const bootstrapDropdown = bootstrap.Dropdown.getInstance(dropdownButton);
        if (bootstrapDropdown) bootstrapDropdown.hide();
      }
    });
  });

  if (dropdownContainer) {
    dropdownContainer.addEventListener('shown.bs.dropdown', function () {
      filterSchools(); 
      if (searchBox) searchBox.focus();
    });

    dropdownContainer.addEventListener('hidden.bs.dropdown', function () {
      if (searchBox) searchBox.value = '';
      filterSchools(); 
    });
  }

  if (studentGrade) {
    studentGrade.addEventListener('change', () => {
      if (hiddenInput) hiddenInput.value = '';
      if (dropdownButton && dropdownButton.querySelector('span')) {
        dropdownButton.querySelector('span').textContent = 'Select...';
      }
      if (otherInput) otherInput.value = '';
      window.schoolDistrict = null;
      filterSchools();
    });
  }
}
